import { AccessTime, Add, Home, MoreHoriz } from '@mui/icons-material';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setFlyoutOpen, setItem } from '../../store/slices/menuSlice';
import MainContainer from '../common/MainContainer';
import FyloutMenu from './FlyoutMenu';
import NavigationRouter from './NavigationRouter';

const NavigationDrawer = () => {
  const { item, flyoutOpen } = useAppSelector((state) => state.menu);
  const loggedIn = useAppSelector((state) => state.auth.loggedIn);
  const dispatch = useAppDispatch();

  const handleChange = (event: any, newValue: any) => {
    if (newValue === 3) {
      dispatch(setFlyoutOpen(!flyoutOpen));
    } else {
      dispatch(setFlyoutOpen(false));
      dispatch(setItem(newValue));
    }
  };

  return (
    <>
      <MainContainer>
        <FyloutMenu />
        {item !== 3 && <NavigationRouter />}
      </MainContainer>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 999 }} elevation={3}>
        <BottomNavigation showLabels value={item} onChange={handleChange}>
          <BottomNavigationAction label="Home" icon={<Home />} />
          {loggedIn && <BottomNavigationAction label="Zeiten" icon={<AccessTime />} />}
          {loggedIn && <BottomNavigationAction label="Eintragen" icon={<Add />} />}
          {loggedIn && <BottomNavigationAction label="Mehr" icon={<MoreHoriz />} />}
        </BottomNavigation>
      </Paper>
    </>
  );
};

export default NavigationDrawer;
